const createFieldItem = (form, field, tabIdx) => {  
  const formItem = {
    tabIdx,
    require: !!field.isRequire,
    _description: !!field._description,
    value: field.fieldType === 'File' ? [] : '',
    error: false,
    validate: v => {
      
      if (field.isRequire && field.fieldType == 'File'  && (!v || v.length == 0)) {
        formItem.error = `${field.fieldName}必须上传`;
        return false;
      } 
      if (field.limit && field.fieldType == 'File'  && (v && v.length > field.limit)) {     
        formItem.error = `${field.fieldName}超过文件数量限制`;
        return false;
      }      
      if (field.isRequire && field.fieldType != 'File' && !v) {
        formItem.error = `${field.fieldName ? field.fieldName :""}必填`;
        return false;
      } 
      console.log('验证类型：'+field.fieldType)
      if (field.isRequire && field.fieldType == 'Table' ) {
        console.log(v)
        formItem.error = `${field.fieldName}必填`;
        return false;
      }

      
      //格式验证
      if(field.validationFormat && v ){
        switch(field.validationFormat){
          case "phone":
            let regex = /^(13[0-9]{9})|(15[0-9]{9})|(17[0-9]{9})|(18[0-9]{9})|(19[0-9]{9})$/;
            if(!v.match(regex)){
              formItem.error = `${field.fieldName}格式不正确，请输入正确手机号码。`;
              return false;
            }
            break;
          default:return true;
        } 
      }
      
      if (field.fieldLength && v && v.length > field.fieldLength ) {
        formItem.error = `${field.fieldName ? field.fieldName :''}字数超过限制，请检查`;
        return false;
      }
      formItem.error = '';
      return true;
    }
  };
  form[field.fieldCode] = formItem;
}

export function createFormAndConfig(config, description = false) {
  const form = {};
  config.map((item, index) => {
    if (item.formConfig) {
      try {
        item.formConfig = JSON.parse(item.formConfig);
        item.formConfig.map((field) => {
          if (field.fieldType !== 'RowTable' && field.fieldType !== 'Table') {
            field._description = description;
            createFieldItem(form, field, index);
          } else {
            const tableForm = {};
            const fieldsColumns = field.childConfig.map(child => {
              child._description = description;
              createFieldItem(tableForm, child, index);
              console.log(tableForm);
              return {
                ...child,
                key: child.fieldCode,
                dataIndex: child.fieldCode,
                name: child.fieldName,
                maxWidth:'100px'
              }
            });
            form[field.fieldCode] = {
              _isTable: true,
              require:field.isRequire,
              columns: !description ? fieldsColumns.concat([{
                key: 'op',
                name: '操作'
              }]) : fieldsColumns,
              tableForm,
              tabIdx:index,
              fieldName:field.fieldName,
              rowsData: []
            };
          }
        })
        console.log('生成的配置表单：'+form);
        // debugger;
      } catch (ex) {
        item.formConfig = [];
      };
    }
    return item;
  });
  return {
    config,
    form
  }
}

// 错误返回 field 正确返回null
export function validateForm(form) {
  for(let key in form) {
    const field = form[key];
    if (field instanceof Object && field.validate && !field.validate(field.value)) {
      return field;
    }
    if (field._isTable) {      
      const rowsData = field.rowsData;
      if(field.require){
        if(!rowsData || rowsData.length == 0){
          return field;
        }
      }
      for (let i = 0; i < rowsData.length; i++) {
        const rowItem = rowsData[i];
        for (let j = 0; j < field.columns; j++) {
          const colItemForm = field.columns[j];
          if (!colItemForm.validateForm(rowItem[colItemForm.fieldCode])) {
            return colItemForm;
          }
        }
      }
    }
  }
  return null;
}

export function getFormValue(form) {
  const valueForm = {};
  for(let key in form) {
    const field = form[key];
    if (field instanceof Object) {
      if (field._isTable) {
        valueForm[key] = form[key].rowsData;
      } else {
        valueForm[key] = form[key].value;
      }
    }
  }
  return valueForm;
}

export function setFormValue(form, valueForm) {
  for(let key in form) {
    const field = form[key];
    if (field instanceof Object) {
      if (field._isTable) {
        form[key].rowsData = valueForm[key];
      } else {
        if(form[key].value instanceof Array){
          if(valueForm[key]){
            form[key].value = valueForm[key];
          }else{
            form[key].value = [];
          }
        }else{
          form[key].value = valueForm[key];  
        }
      }
    }
  }
  return form;
}